import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Protects ads module routes. Only allows access when ad creator is logged in (adToken present).
 * Admin token is not used here, so ad creators cannot access admin dashboard and vice versa.
 */
const AdsProtectedRoute = ({ children }) => {
  const location = useLocation();
  const adToken = typeof window !== 'undefined' ? localStorage.getItem('adToken') : null;

  if (!adToken) {
    return <Navigate to="/ads/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdsProtectedRoute;
